import api, { HttpResponse } from '../utils/api'
import { RouteModel, ErrorModel, LocationModel } from '../common/models/CommonModels';
import { apiBaseUrl } from '../env';

export interface RouteResult {
    fromId: string;
    toId: string;
    points: RoutePoints;
    distance: number;
}

interface RoutePoints {
    pointCount: number;
    points: Array<[number, number]>;
}

export function getRoute(fromId: string, toId: string,): Promise<RouteResult | undefined> {

    fromId = fromId.toUpperCase();
    toId = toId.toUpperCase();

    const url = `api/routes/?fromLocationId=${fromId}&toLocationId=${toId}`;

    return api.get(url).then((response: HttpResponse) => {
        if (response.status === 200) {
            const data: RouteResult = <RouteResult>response.data;
            return data;
        }

        return undefined;
    });
}

export function getRouteModel(id: string, from: LocationModel, to: LocationModel, routeResult: RouteResult): RouteModel{
    return {
        from,
        to,
        route: routeResult.points.points,
        target: {
            id,
            departureCity: from,
            destinationCity: to,
        },
        distance: routeResult.distance,
    }
}


// WEBPACK FOOTER //
// ./src/api/routesApi.ts